<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar :goodsNumber="goodsNumber" :tabbarIndex="1"></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="main">
      <div class="df-maina-ddtit"><span>批量导入订单支付</span></div>
      <div class="goBack">
        <el-button
          size="small"
          style="width:90px;margin-top:50px;background:#9cbbd8;color:#fff;"
          @click="goBack"
        >
          返 回
        </el-button>
      </div>
      <div class="df-buyf" v-if="currentPageInfo.length > 0">
        <div class="info" v-for="(item, index) of currentPageInfo" :key="index">
          <div class="top">{{ index + 1 }}.子订单信息</div>
          <div class="middle">
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">订单创建时间:</div>
                <div class="right">{{ item.createTime || "暂无" }}</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">订单状态:</div>
                <div class="right right1">
                  <span>{{ order_status(item.status) || "" }}</span>
                </div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">订单编号:</div>
                <div class="right">{{ item.orderNum || "暂无" }}</div>
                <div class="copy" @click="copyText(item.orderNum)">复制</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">运费:</div>
                <div class="right">{{ to_f(item.moneyYun || "0.00") }}</div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">商品费用:</div>
                <div class="right">{{ to_f(item.moneyGoods || "0.00") }}</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">总金额:</div>
                <div class="right">{{ to_f(item.money || "0.00") }}</div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">收货人:</div>
                <div class="right">{{ item.consignee || "暂无" }}</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">联系方式:</div>
                <div class="right">{{ item.consigneePhone || "暂无" }}</div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">收货地址:</div>
                <div class="right">
                  {{
                    (item.province || "") +
                      (item.city || "") +
                      (item.area || "") +
                      item.consigneeAddr || "暂无"
                  }}
                </div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">商品信息:</div>
                {{ item.goodsDetail || "暂无" }}
              </div>
            </div>

            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">快递方式:</div>
                <el-select
                  v-model="item.deliveryId"
                  :disabled="item.isEditDelivery == 1 || isEditDelivery != 0"
                  @change="changeKD(index)"
                  size="small"
                  placeholder="请选择快递方式"
                >
                  <el-option
                    v-for="(item2, index2) in item.kdAry"
                    :key="index2"
                    :label="item2.deliveryName"
                    :value="item2.deliveryId"
                    :disabled="item2.isWeb == '0' && item2.status == '1'"
                  >
                  </el-option>
                </el-select>
                <span class="change">(点击可进行选择)</span>
              </div>
            </div>
            <div class="line line3 flexStyle2">
              <div class="item flexStyle2">
                <div class="left">是否开票:</div>
                <span :class="item.isInvoice ? '' : 'ku'">
                  <el-radio-group
                    v-model="item.isInvoice"
                    @change="invoiceChange(index)"
                  >
                    <el-radio label="0">开票</el-radio>
                    <el-radio label="1">不开票</el-radio>
                  </el-radio-group>
                </span>
              </div>
            </div>
          </div>
          <!--<div class="bottom">
            <el-button
              icon="el-icon-receiving"
              type="primary"
              size="small"
              style="width:110px;"
              @click="chooseKP(index)"
            >
              选择开票
            </el-button>
          </div>-->
        </div>
      </div>
      <div class="bottom" v-else>{{ tipMsg }}</div>
      <div class="df-buyg">
        <el-row>
          <el-col :span="6" v-if="isEditDelivery == 0"
            >快递方式：
            <el-select
              v-model="deliveryId"
              @change="changeKD(-1)"
              size="small"
              placeholder="请选择快递方式"
            >
              <el-option
                v-for="(item2, index2) in kdList2"
                :key="index2"
                :label="item2.deliveryName"
                :value="item2.deliveryId"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="getSpan2()">
            <el-button
              size="small"
              style="width:110px;background:#9cbbd8;color:#fff;"
              @click="chooseKP2"
            >
              选择开票
            </el-button></el-col
          >
          <el-col :span="14" align="right">
            <div class="total">
              <span
                >商品：<span>{{ to_f(totalGoods) }}元</span></span
              >
              <span
                >运费：<span>{{ to_f(totalYF) }}元</span></span
              >
              <span
                >总计：<span>{{ to_f(totalMoney) }}元</span></span
              >
              <el-button
                v-if="isPrice"
                size="small"
                style="width:110px;background:#9cbbd8;color:#fff;"
                @click="choosePrice"
              >
                去调价
              </el-button>
              <el-button
                size="small"
                style="width:120px;background:#9cbbd8;color:#fff;"
                @click="submitPay"
              >
                确认支付
              </el-button>
            </div></el-col
          >
        </el-row>
      </div>
    </div>

    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->

    <!-- 100.kp-container-start -->
    <el-dialog title="选择开票" top="28vh" width="400px" :visible.sync="kpShow">
      <el-form :model="formKp">
        <el-form-item label="" label-width="60px">
          <el-radio-group v-model="formKp.isInvoice" @change="submitKP">
            <el-radio label="0">开票</el-radio>
            <el-radio label="1">不开票</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 100.kp-container-end -->
    <el-dialog title="价格调整" :visible.sync="priceShow">
      <el-form :model="form">
        <el-form-item label="产品名称" :label-width="formLabelWidth">
          <el-select v-model="form.goodsId" placeholder="请选择订单产品">
            <el-option
              v-for="item in goodsAry"
              :key="item.goodsId"
              :label="item.goodsName"
              :value="item.goodsId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="产品价格" :label-width="formLabelWidth">
          <el-input v-model="form.price" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePrice">确 定</el-button>
        <el-button @click="closePriceShow">取 消</el-button>
      </div>
    </el-dialog>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import * as math from "mathjs";
import {
  shoppingCarNumber,
  kdListRequest,
  kdChooseRequest,
  openTicketRequest,
  interOrderDetail2Request,
  editOrderGoodsPriceRequest,
} from "../../public/js/service";
import { getUserBaseInfoRequest } from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      currentPageInfo: [], // 1.1.currentPageInfo
      token: "", // 1.2.token
      batchId: "", // 1.3.批量订单id
      kd: "", // 1.4.快递
      kdList: [], // 1.5.快递列表
      kdList2: [],
      kdShow: false, // 1.6.快递遮罩层
      kpShow: false, // 1.6.1.开票遮罩层
      chooseKDOrderIndex: 0, // 1.7.选择快递的订单index
      chooseKDindex: "-1", // 1.8.选择快递的index
      goodsNumber: 0, // 1.9.购物车商品数量
      formLabelWidth: "120px",
      priceShow: false,
      isM2: 0,
      deliveryId: null,
      form: { batchId: null, goodsId: null, price: null },
      goodsAry: [],
      userInfo: {},
      isPrice: false,
      tipMsg: "正在加载数据...",
      formKp: { isInvoice: null },
      isEditDelivery: 1,
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.tabbar
    cFooter: footer, // 2.2.footer
  },

  methods: {
    // 3.methods
    copyText(value) {
      // 3.1.copyText
      let inputObject = document.createElement("input");
      document.body.appendChild(inputObject);
      inputObject.style.visibility = "none";
      inputObject.value = value;
      inputObject.select();
      document.execCommand("copy");

      this.$message({
        showClose: true,
        message: "已复制到剪切板",
        type: "success",
      });
      inputObject.style.display = "none";
    },

    goBack() {
      // 3.2.返回
      this.$router.go(-1);
    },

    getKDInfo() {
      // 3.3.获取快递信息
      kdListRequest().then((res) => {
        if (res) {
          this.kdList = res.data;
          let ary = [];
          for (let j = 0; j < res.data.length; j++) {
            let r = res.data[j];
            if (r.isWeb == "0" && r.status == "0") {
              if (
                (r.isWebPlat || "0") == "0" ||
                (r.isWebSupplier || "0") == "0"
              ) {
                ary.push(r);
              }
            }
          }
          this.kdList2 = ary;
        }
      });
    },
    invoiceChange(v) {
      let orderId = this.currentPageInfo[v].orderId;
      let isInvoice = this.currentPageInfo[v].isInvoice;
      let param = { orderId: orderId, isInvoice: isInvoice };
      openTicketRequest(param).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });
        }
      });
    },

    closeKDShow() {
      // 3.6.关闭快递遮罩层
      this.kdShow = false;
      this.chooseKDindex = "-1";
      this.chooseKDOrderIndex = 0;
    },

    chooseKP(index) {
      // 3.7.选择开票
      this.chooseKDOrderIndex = index;
      this.kpShow = true;
      this.isM2 = 1;
      this.formKp.isInvoice = this.currentPageInfo[index].isInvoice;
    },

    chooseKP2() {
      // 3.7.选择开票
      this.formKp.isInvoice = null;
      this.kpShow = true;
      this.isM2 = 2;
    },

    closeKPShow() {
      // 3.8.关闭开票遮罩层
      this.kpShow = false;
      this.chooseKDOrderIndex = 0;
    },

    submitKP(isInvoice) {
      // 3.9.确认开票
      if (this.isM2 == 1) {
        let orderId = this.currentPageInfo[this.chooseKDOrderIndex].orderId;
        let param = { orderId: orderId, isInvoice: isInvoice };
        if (this.currentPageInfo[this.chooseKDOrderIndex] != isInvoice) {
          openTicketRequest(param).then((res) => {
            if (res) {
              this.$message({
                type: "success",
                message: res.msg,
              });

              this.currentPageInfo[
                this.chooseKDOrderIndex
              ].isInvoice = isInvoice;
              this.kpShow = false;
              this.chooseKDOrderIndex = 0;
            }
          });
        } else {
          this.$message({
            type: "error",
            message: "重复操作！",
          });
        }
      }

      if (this.isM2 == 2) {
        let param = { batchId: this.batchId, isInvoice: isInvoice };
        openTicketRequest(param).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getCurrentPageInfo();
            this.kpShow = false;
            this.chooseKDOrderIndex = 0;
          }
        });
      }
    },

    submitPay() {
      // 3.10.确认支付
      this.obj2.res = this.printFn(this.totalMoney);
      this.$router.push(
        "/pay?obj2=" + encodeURIComponent(JSON.stringify(this.obj2))
      );
    },

    getGoodsNumber() {
      // 3.11.获取购物车信息
      shoppingCarNumber().then((res) => {
        if (res) {
          this.goodsNumber = res.data;
        }
      });
    },

    printFn(value) {
      // 3.12.精度算数
      const precision = 14;
      return Number(math.format(value, precision));
    },
    getSpan2() {
      return this.isEditDelivery == 0 ? 4 : 10;
    },
    changeKD(index) {
      // 3.13.选择快递

      if (index < 0) {
        let data = {
          deliveryId: this.deliveryId,
          batchId: this.batchId,
        };
        kdChooseRequest(data).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getCurrentPageInfo();
          }
        });
      }

      if (index >= 0) {
        let data = {
          deliveryId: this.currentPageInfo[index].deliveryId,
          orderId: this.currentPageInfo[index].orderId,
        };

        kdChooseRequest(data).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getCurrentPageInfo();
          }
        });
      }
    },

    getCurrentPageInfo() {
      // 3.14.获取信息
      interOrderDetail2Request(this.batchId).then((res) => {
        if (res) {
          //this.currentPageInfo = res.data;
          this.currentPageInfo = res.data.map((item) => {
            if (item.isInvoice) {
              console.log(item.isInvoice);
            } else {
              item.isInvoice = 1;
            }

            let kdAry = [];
            for (let p = 0; p < this.kdList.length; p++) {
              let dd = this.kdList[p];
              if (item.isSupplier == "0") {
                if (item.isEditDelivery == "0") {
                  if ((dd.isWebPlat || "0") == "0") {
                    kdAry.push(dd);
                  }
                } else {
                  if (dd.deliveryId == item.deliveryId) {
                    kdAry.push(dd);
                  }
                }
              }
              if (item.isSupplier == "1") {
                if ((dd.isWebSupplier || "0") == "0") {
                  kdAry.push(dd);
                }
              }
            }
            item.kdAry = kdAry;
            return item;
          });
        }
      });
    },
    choosePrice() {
      // 3.11.选择修改商品
      this.priceShow = true;
      let ary = [];
      for (let j = 0; j < this.currentPageInfo.length; j++) {
        let goods = this.currentPageInfo[j].orderItemList;
        if (goods) {
          for (let i = 0; i < goods.length; i++) {
            let goodsId = goods[i].goodsId;
            let item = ary.find((item) => {
              return item.goodsId == goodsId;
            });
            if (item) {
              console.log(item);
            } else {
              ary.push(goods[i]);
            }
          }
        }
      }
      this.goodsAry = ary;
    },
    closePriceShow() {
      // 3.10.关闭开票遮罩层
      this.priceShow = false;
    },
    savePrice() {
      // 3.12
      this.form.batchId = this.batchId;
      let _this = this;

      this.$msgbox({
        title: "提示",
        message: "您确定要调整价格?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.editOrderGoodsPrice(_this.form);
          }
        },
      });
    },
    editOrderGoodsPrice(item) {
      let _this = this;
      editOrderGoodsPriceRequest(item).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          _this.priceShow = false;
          setTimeout(() => {
            this.getCurrentPageInfo();
          }, 300);
        }
      });
    },
    getUserInfo() {
      // 3.4.获取用户信息
      getUserBaseInfoRequest().then((res) => {
        if (res) {
          this.userInfo = res.data;
          if (this.userInfo.isModifyPrice == "0") {
            this.isPrice = true;
          }
          localStorage.userInfo = JSON.stringify(res.data);
        }
      });
    },
  },

  mounted() {
    // 4.mounted
    if (this.$route.query.obj2) {
      this.obj2 = JSON.parse(decodeURIComponent(this.$route.query.obj2));
      this.batchId = this.obj2.batchId;
      this.batchName = this.obj2.batchName || "";

      if (localStorage.token) {
        this.token = localStorage.token;
        this.getKDInfo();
        this.getGoodsNumber();
        this.getUserInfo();
        setTimeout(() => {
            this.getCurrentPageInfo();
          }, 200);
      }
    }
  },

  computed: {
    // 5.computed
    totalGoods() {
      // 5.1.totalGoods
      let res = 0;
      this.currentPageInfo.forEach((item) => {
        if (item.status != "4") {
          res += item.moneyGoods;
        }
      });
      return this.printFn(res);
    },

    totalYF() {
      // 5.2.totalYF
      let res = 0;
      this.currentPageInfo.forEach((item) => {
        if (item.status != "4") {
          res += item.moneyYun;
        }
      });
      return this.printFn(res);
    },

    totalMoney() {
      // 5.2.totalMoney
      let res = 0;
      this.currentPageInfo.forEach((item) => {
        if (item.status != "4") {
          res += item.money;
        }
      });
      return this.printFn(res);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./orderPay.scss";
</style>
